import { Card, Flex, Typography, Space } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

export const AuditType = ({ type, Icon, selected, onClick }) => {
  return (
    <Card
      size="small"
      onClick={onClick}
      style={selected === type.value ? { border: '1px solid #00506c', background: '#f9fdff', color: '#00506c' } : {}}>
      <Flex align="center" gap={16}>
        <div
          style={{
            background: type.iconBg,
            borderRadius: 12,
            width: 56,
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Icon style={{ fontSize: '1.25' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            {type.title}
          </Typography.Title>
          <Typography.Text>{type.description}</Typography.Text>
          <Space style={{ marginTop: 8 }}>
            <CalendarOutlined style={{ color: '#b0b7c3' }} />
            <Typography.Text type="secondary" italic>
              {type.note}
            </Typography.Text>
          </Space>
        </div>
      </Flex>
    </Card>
  );
};
